import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { resetPassword } from '../utils/api';

export default function ResetPassword() {
  const { search } = useLocation();
  const navigate  = useNavigate();
  const params    = new URLSearchParams(search);
  const token     = params.get('token');

  const [password,              setPassword]              = useState('');
  const [showPassword,          setShowPassword]          = useState(false);
  const [passwordConfirmation,  setPasswordConfirmation]  = useState('');
  const [showPasswordConfirm,   setShowPasswordConfirm]   = useState(false);
  const [status,                setStatus]                = useState(null);
  const [message,               setMessage]               = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing reset token. Please use the link from your email.');
    }
  }, [token]);

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus(null);
    setMessage('');

    if (password !== passwordConfirmation) {
      setStatus('error');
      setMessage('Passwords do not match.');
      return;
    }

    try {
      await resetPassword({ token, password, password_confirmation: passwordConfirmation });
      setStatus('success');
      setMessage('Password has been reset! Redirecting to login…');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4 text-center">Reset Your Password</h3>

          {status === 'success' && (
            <div className="alert alert-success" role="alert">
              {message}
            </div>
          )}
          {status === 'error' && (
            <div className="alert alert-danger" role="alert">
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3 password-input-wrapper">
              <label htmlFor="password" className="form-label">New Password</label>
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(v => !v)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="mb-3 password-input-wrapper">
              <label htmlFor="passwordConfirmation" className="form-label">
                Confirm New Password
              </label>
              <input
                id="passwordConfirmation"
                type={showPasswordConfirm ? 'text' : 'password'}
                className="form-control"
                value={passwordConfirmation}
                onChange={e => setPasswordConfirmation(e.target.value)}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowPasswordConfirm(v => !v)}
              >
                {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
